import { render, staticRenderFns } from "./forum.vue?vue&type=template&id=fe0ae2aa&scoped=true&"
import script from "./forum.vue?vue&type=script&lang=js&"
export * from "./forum.vue?vue&type=script&lang=js&"
import style0 from "./forum.vue?vue&type=style&index=0&id=fe0ae2aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0ae2aa",
  null
  
)

export default component.exports